import type { HTMLAttributes, ReactNode } from 'react';

import React from 'react';

import { CheckCircleIcon, CloseIcon } from '../../icons';
import { classNames } from '../../utils/class-names';

import styles from './notification.module.css';

export type NotificationProps = {
  status?: 'success' | 'error';
  text?: string;
  icon?: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

/**
 * @param {'success' | 'error'} [status] The status of confirmation message
 * @default undefined
 * @param {string} [text] Text of confirmation message
 * @default undefined
 */
export function Notification({ status, text, icon, className, ...props }: NotificationProps) {
  return (
    <div
      data-testid="notification"
      className={classNames(
        styles.notification,
        status === 'success' && styles.success,
        status === 'error' && styles.error,
        className
      )}
      {...props}
    >
      {status === 'success' && <CheckCircleIcon />}
      {status === 'error' && <CloseIcon />}
      {icon}
      {text}
    </div>
  );
}
